module.exports = __webpack_public_path__ + "static/media/logo-medium.ac578606.png";